module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.visible,
      "size": "tiny",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      },
      "close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "m-token-content"
  }, [(!_vm.isBinder) ? _c('div', {
    staticClass: "binding"
  }, [_c('p', [_vm._v("请使用“M令牌”App扫描二维码，然后输入6位动态验证码完成绑定。")]), _vm._v(" "), _c('div', {
    ref: "secretRef",
    staticClass: "qr-code"
  }), _vm._v(" "), _c('p', {
    staticClass: "secret"
  }, [_vm._v("无法扫码时可手动输入密钥：" + _vm._s(_vm.secret))])]) : _vm._e(), _vm._v(" "), _c('el-input', {
    attrs: {
      "maxlength": 6,
      "autofocus": "",
      "placeholder": "请输入M令牌生成的6位动态验证码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submit.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.token),
      callback: function($$v) {
        _vm.token = $$v
      },
      expression: "token"
    }
  }), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("校验")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-666469e6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mToken/mTokenDialog.vue
// module id = 554
// module chunks = 1